import { REHYDRATE } from "redux-persist";
import {
  selectIsMedium,
  selectIsLessThanMedium
} from "~/store/ducks/application/browser";
import {
  closeSidebarLeft,
  closeSidebarRight,
  selectLeftSidebarIsOpen,
  selectRightSidebarIsOpen
} from "~/store/ducks/user/uistate";
import { setPageMode, selectPageMode } from "~/store/ducks/application/page";
import { SINGLE_PER_PAGE } from "~/constants/page-modes";

const middleware = store => next => action => {
  if (action && action.type === REHYDRATE) {
    const { dispatch, getState } = store;
    const state = getState();

    if (selectIsMedium(state) || selectIsLessThanMedium(state)) {
      if (selectPageMode(state) !== SINGLE_PER_PAGE) {
        dispatch(setPageMode(SINGLE_PER_PAGE));
      }

      if (selectLeftSidebarIsOpen(state)) {
        dispatch(closeSidebarLeft());
      }

      if (selectRightSidebarIsOpen(state)) {
        dispatch(closeSidebarRight());
      }
    }
  }

  return next(action);
};

export default middleware;
